import { createSlice } from '@reduxjs/toolkit';

export interface DemoImageData {
  name: string;
  url?: string;
  uploadState?: boolean;
  sampleImg: boolean;
  pageIndex?: number;
  isPdf?: boolean;
  isTif?: boolean;
  angle?: number;
};

export type ImagesDataArray = Array<DemoImageData>;

const initialState: ImagesDataArray = [
  {
    name: "AllSupportedBarcodeTypes.png",
    uploadState: true,
    sampleImg: true,
  },
  {
    name: "batch-scan.jpg",
    uploadState: true,
    sampleImg: true
  },
  {
    name: "DamagedBarcodes.png",
    uploadState: true,
    sampleImg: true
  },
  {
    name: "BarcodeColorMode.png",
    uploadState: true,
    sampleImg: true
  },
  {
    name: "blurryEffect_DPM.png",
    uploadState: true,
    sampleImg: true
  }
];

const imgDataSlice = createSlice({
  name: 'imagesData',
  initialState,
  reducers: {
    addImage: (state, action) => {
      state.push(...action.payload);
    },
    deleteImage: (state, action) => {
      state.splice(action.payload.index, 1)
    },
    updateImageDataState: (state, action) => {
      for (let i = 0; i < state.length; i++) {
        if (state[i].name === state[action.payload.currentImageIndex].name) {
          state[i].uploadState = action.payload.uploadState;
        }
      }
    }
  },
});

export const { addImage, updateImageDataState, deleteImage } = imgDataSlice.actions;

export default imgDataSlice.reducer;